import React, { useState, useEffect } from "react";

import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useHistory, useParams } from "react-router-dom";

import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { obternerRegistroxID } from "../utils/Actions";
import _, { size } from "lodash";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Loading } from "../atoms";
import moment from "moment";
import { saveAs } from "file-saver";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  icon: {
    alignSelf: "center",
  },
  avatar: {
    width: 100,
    height: 100,
    marginBottom: 20,
  },
}));

export default function VisitDetails() {
  let { id } = useParams();
  const visitid = id.slice(4);
  let history = useHistory();
  const classes = useStyles();
  const [state, setstate] = useState(false);
  const [visible, setVisible] = useState(false);
  const [account, setaccount] = useState("");
  const [img, setimg] = useState("");
  const [open, setopen] = useState(false);

  useEffect(() => {
    (async () => {
      setVisible(true);
      const response = await obternerRegistroxID("Visits", visitid);
      const response1 = await obternerRegistroxID(
        "Accounts",
        response.data.accountId
      );
      setaccount(response1.data.name);
      console.log(response.data);
      setstate(response.data);
      setVisible(false);
    })();
  }, []);

  const getUpdate = (fecha) => {
    let response = "";
    if (new Date(fecha).getFullYear() < 2000) {
      response = "-";
    } else {
      response = moment(fecha).format("LT");
    }
    return response;
  };

  const handleClose = () => {
    setopen(false);
  };

  const downloadimage = () => {
    saveAs(`${img}.jpg`, "image.jpg");
  };

  return (
    state && (
      <FormControl
        style={{
          backgroundColor: "#fff",
          borderRadius: 5,
          padding: 20,
          paddingBottom: 30,
        }}
      >
        <Typography gutterBottom variant="h5">
          <IconButton>
            <ChevronLeftIcon onClick={() => history.goBack()} />
          </IconButton>
          Visita {account}
        </Typography>

        <Grid
          item
          xs={6}
          direction="row"
          justify="center"
          alignItems="center"
          container
          spacing={0}
          style={{ marginBottom: 20 }}
        ></Grid>
        <Grid container spacing={5}>
          <Grid item xs={6} sm={6}>
            <TextField
              label="Nombre"
              fullWidth
              name="name"
              value={state.name}
              onSubmit={() => {
                console.log("salio");
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <TextField
              label="Identificación"
              fullWidth
              name="identification"
              value={state.identification}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Apartamento"
              fullWidth
              name="aparment"
              value={state.aparment}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Piso"
              fullWidth
              name="floor"
              value={state.floor}
            />
          </Grid>

          <Grid item xs={4}>
            <TextField
              label="Fecha"
              fullWidth
              name="createdAt"
              value={moment(state.createdAt.toDate()).format("ll")}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Hora De Entrada"
              fullWidth
              name="hour"
              value={moment(state.createdAt.toDate()).format("LT")}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Hora de Salida"
              fullWidth
              name="userupdated"
              value={getUpdate(state.updatedAt.toDate())}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vehículo"
              fullWidth
              name="vehiculo"
              value={_.get(state, "vehiculemodel", "No registrado")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Placa"
              fullWidth
              name="Placa"
              value={state.idvehicule}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Motivo"
              fullWidth
              name="typedescription"
              value={_.get(state, "typedescription", "No registrado")}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Descripción Motivo"
              fullWidth
              name="Motivo"
              value={_.get(state, "motivo", "No registrado")}
            />
          </Grid>

          <Grid
            item
            xs={12}
            direction="row"
            justify="center"
            alignItems="center"
            container
            spacing={0}
          >
            {size(state.photoplaca) > 0 && (
              <div>
                <img
                  alt="Photo"
                  src={state.photoplaca}
                  style={{
                    width: 250,
                    height: 200,
                    margin: 10,
                    borderRadius: 10,
                  }}
                  onClick={() => {
                    setimg(state.photoplaca);
                    setopen(true);
                  }}
                />
              </div>
            )}
            {size(state.photoid) > 0 && (
              <img
                alt="Photo"
                src={state.photoid}
                style={{
                  width: 250,
                  height: 200,
                  margin: 10,
                  borderRadius: 10,
                }}
                onClick={() => {
                  setimg(state.photoid);
                  setopen(true);
                }}
              />
            )}
          </Grid>
        </Grid>
        <Loading visible={visible} setVisible={setVisible} />

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Imagen</DialogTitle>
          <DialogContent>
            {/*<DialogContentText>
            To subscribe to this website, please enter your email address here.
            We will send updates occasionally.
           </DialogContentText>*/}
            <img src={img} style={{ width: 500, height: 500 }} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cerrar
            </Button>

            <Button onClick={downloadimage} color="primary">
              Descargar
            </Button>
          </DialogActions>
        </Dialog>
      </FormControl>
    )
  );
}
